import React from 'react';
import { FadeIn } from './FadeIn';
import { ShieldCheckIcon } from 'lucide-react';
export function Guarantee() {
  return <section className="py-16 px-4 bg-hyrox-surface" data-id="element-70">
      <div className="max-w-3xl mx-auto text-center" data-id="element-71">
        <FadeIn data-id="element-72">
          <ShieldCheckIcon className="w-16 h-16 text-hyrox-orange mx-auto mb-6" data-id="element-73" />
          <h2 className="text-3xl font-display font-bold text-white mb-6" data-id="element-74">
            La garantía es simple porque el producto es serio.
          </h2>
          <p className="text-lg text-gray-300 leading-relaxed mb-6" data-id="element-75">
            Abrís los tomos. Los usás en tus clases. Si en 7 días no es
            exactamente lo que esperabas, te devolvemos el 100% del dinero. Sin
            formularios. Sin preguntas. Sin drama.
          </p>
          <div className="inline-block bg-hyrox-dark border border-hyrox-muted px-6 py-4 rounded-xl" data-id="element-76">
            <p className="text-hyrox-orange font-bold text-lg" data-id="element-77">
              La tasa de devolución es menor al 1%.
            </p>
            <p className="text-sm text-gray-400 mt-1" data-id="element-78">
              No porque tengamos una política difícil. Sino porque el sistema
              funciona y los coaches que lo implementan lo ven rápido.
            </p>
          </div>
        </FadeIn>
      </div>
    </section>;
}